module.exports = __webpack_public_path__ + "img/block_press down_02.57fed53b.png";